
import { mapState } from 'vuex';
import SpamReportForm from '@/views/dialog/components/SpamReportForm';

export default {
  name: 'SpamReportFormDialog',
  components: { SpamReportForm },
  data() {
    return {
      isSubmitting: false,
      formValues: {}
    };
  },
  computed: {
    ...mapState(['api']),
    ...mapState('window', ['windowService']),
    initialTab() {
      return this.$route.query.selected_spam_type_tab === 'brand_user'
        ? 'brand_user'
        : 'article';
    },
    isArticleBlocked() {
      return this.$route.query.article_blocked === 'true';
    },
    articleBlockedMessage() {
      return this.isArticleBlocked ? this.$t('already_blocked') : '';
    },
    spamReportableParams() {
      const query = this.$route.query;
      return {
        spam_reportable_id: query.spam_reportable_id,
        spam_reportable_type: query.spam_reportable_type,
        spam_reportable_brand_user_id: query.spam_reportable_brand_user_id
      };
    }
  },
  methods: {
    onFormChange(formValues) {
      this.formValues = formValues;
    },
    alertBlockedArticle(message) {
      this.windowService.alert(message);
    },
    submit() {
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      return this.api
        .createSpamReport({
          ...this.spamReportableParams,
          ...this.formValues
        })
        .then(({ data }) => {
          this.windowService.alert(data.message);
          this.windowService.closeFullscreenPopup(
            data.blocked ? 'blocked' : 'reported'
          );
        })
        .catch(() => this.windowService.alert(this.$t('error')))
        .finally(() => (this.isSubmitting = false));
    },
    close() {
      this.windowService.closeFullscreenPopup();
    }
  }
};
